import { MisterIcon } from "@rtel/mister-icons";
import style from "./FilterButton.module.scss";

const FilterButton = (props: FilterButtonProps) => {
    return <>
      
            <button
                onClick={props.onClick}
                className={`${style.container} btn right-bar-toggle ${props.isRightBarOpen && style.active}`}
            >
                {props.isActive && <span className={style.activeCircle}></span>}
                <span className="d-block text-center">
                    <MisterIcon name="Filter" size="sm" className={style.filterIcon} />
                </span>
            </button>
   
    </>
}

interface FilterButtonProps {
    onClick: () => void;
    isActive: boolean;
    isRightBarOpen: boolean;
}

export default FilterButton;